var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Show",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.329,
    height: 46.859,
    viewBox: "0 0 80.329 46.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #abafd1;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #6610f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13612",
    "data-name": "Path 13612",
    className: "cls-1",
    d: "M1.478,19.726a5.378,5.378,0,0,0,0,7.406c6.068,6.6,20.425,19.726,38.686,19.726S72.783,33.736,78.851,27.133a5.378,5.378,0,0,0,0-7.406C72.783,13.123,58.426,0,40.165,0S7.547,13.123,1.478,19.726ZM40.165,6.694c-14.448,0-26.623,10.234-32.782,16.735,6.158,6.5,18.334,16.735,32.782,16.735S66.788,29.931,72.946,23.429C66.788,16.928,54.612,6.694,40.165,6.694Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13613",
    "data-name": "Path 13613",
    className: "cls-2",
    d: "M9,14.041A10.041,10.041,0,1,0,19.041,4,10.041,10.041,0,0,0,9,14.041Zm6.694,0a3.347,3.347,0,1,0,3.347-3.347A3.347,3.347,0,0,0,15.694,14.041Z",
    transform: "translate(21.124 9.388)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.7e12c673d0d1db1fd9692c0facff2826.svg";
export { ForwardRef as ReactComponent };